// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__P0Nr5","sidebar--open":"Sidebar_sidebar--open__-lEeU","sidebar__logo":"Sidebar_sidebar__logo__Qpl3x","sidebar__menus":"Sidebar_sidebar__menus__QI3xf"};